import './PostCommentPanel.scss'

import React, { PureComponent } from 'react'
import EditableRichTextField from '../EditableRichTextField'
import { EditorState, ContentState } from 'draft-js'
import PropTypes from 'prop-types'

const MAX_LENGTH = 4000

class PostCommentPanel extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      currentComment: '',
      editorState: EditorState.createEmpty()
    }
  }

  getCurrentComment = () => {
    return this.state.editorState.getCurrentContent().getPlainText()
  }

  saveComment = () => {
    this.props.addComment(this.getCurrentComment())
    this.setState(prevState => {
      const editorState = EditorState.push(prevState.editorState, ContentState.createFromText(''))
      return { editorState }
    })
  }

  render() {
    let { localize } = this.props
    return <div className='post-comment-panel'>
      <div className='post-comment-panel__comment-input'>
        <EditableRichTextField
          placeHolderText={localize('taskBoards.Text_WriteAComment')}
          editorState={this.state.editorState}
          onChange={(editorState) => this.setState({ editorState })}
          maxLength={MAX_LENGTH} />
      </div>
      <button
        className='post-comment-panel__submit-button cp-button submit-button gutter-left'
        type='button'
        onClick={this.saveComment}
        disabled={!this.getCurrentComment().trim()}>
          { localize('taskBoards.Label_PostComment') }
        </button>
    </div>
  }
}

PostCommentPanel.propTypes = {
  addComment: PropTypes.func.isRequired,
  localize: PropTypes.func.isRequired
}

export default PostCommentPanel



// WEBPACK FOOTER //
// ./src/components/PostCommentPanel/PostCommentPanel.js